import {
  Component,
  OnInit,
  computed,
  input,
  output,
  signal,
  Inject,
} from '@angular/core';
import { NavigationBehaviorOptions, NavigationStart, Router, UrlTree } from '@angular/router';

import { Image } from '@frontend/core';
import { MainNavigationLink } from '../main-navigation-link.model';
import { Brand, BrandDisplayService } from '../../branding';
import { AuthService, User, UserRole } from '../../auth';
import { Subscription } from 'rxjs';
import {  AvailableLanguage,
          LanguageService,
          MediaService,
          AccountDropdownLink,
          AccountDropdownLinks,
         } from '@frontend/common';


@Component({
  selector: 'multisite-main-navigation',
  templateUrl: './main-navigation.component.html',
  styleUrls: ['./main-navigation.component.scss'],

  standalone: false,
})
export class MainNavigationComponent implements OnInit {
  // sidenavToggleButtonDisabled: boolean;
  changeSidenavMode = output<void>();
  logout = output<void>();
  user = input<User | undefined>(undefined);
  sidenavMode = input<string | undefined>(undefined);
  currentBrandSubscription: Subscription | undefined;
  brand = signal<Brand | null>(null);
  logo = input<string | undefined>(undefined); // 'culturettt' or 'icpendulum'
  navCollapsed : boolean = true;
  navLinks = input<MainNavigationLink[] | undefined>(undefined);
  loading = input<boolean | undefined>(undefined);
  activeLanguageSubscription: Subscription | undefined;
  activeLanguageObject : AvailableLanguage | undefined;
  availableLanguages : AvailableLanguage[];
  accountDropdownLinks : AccountDropdownLink[] = AccountDropdownLinks;

  constructor(
    private router: Router,
    private brandDisplayService: BrandDisplayService,
    private authService: AuthService,
    private languageService: LanguageService,
    private mediaService: MediaService,
    @Inject('appKey') private appKey: string,
    ) {
      this.accountDropdownLinks = AccountDropdownLinks;
      this.router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
            this.hideNav();
        }
        
        // if (event instanceof NavigationEnd) {
          //     let url = event.url;          
          //     console.log('The new url is '+event.url);
          //     if (event.url.indexOf('demos')>-1){
            //       this.isDemo = true; // we need to hide the footer; it conflicts with the canvas
            //     } else {
              //       this.isDemo = false;
              //     }
              // }
    });
    this.availableLanguages = this.languageService.availableLanguages;
}

  setActiveLanguage(languageKey : string){ 
    this.languageService.setLanguage(languageKey);
  }
  getFlagUrl(availableLanguage:AvailableLanguage,transformations:string, file_extension:string){
    return this.mediaService.getFlagUrlFromHash(availableLanguage?.flag.hash,transformations,true,file_extension);
  }
  navigateTo(url: string | UrlTree, extras?: NavigationBehaviorOptions) {
    this.router.navigateByUrl(url, extras);
  }
  isAdmin (){
    return this.authService.checkRole("Admin");
  }
  hasRole (roleName:string){
    return this.authService.checkRole(roleName); // for example "Admin"
  }

  hideNav(){
    this.navCollapsed = true;
  }
  toggleSidenavMode() {
    this.changeSidenavMode.emit();
  }
  darkModeActive () {
    return this.brandDisplayService.darkMode;
  }
  getLogoFile(type : string) : Image | null {
    const brand = this.brand();
    if(!brand){
      return null;
    }
    if (type === 'logo_banner'){
      if (this.darkModeActive() && brand?.logo_banner_inverse){
        return brand.logo_banner_inverse;
      } else {
        return brand.logo_banner;
      };
    } else {
      if (this.darkModeActive() && brand?.logo_square_inverse){
        return brand.logo_square_inverse;
      } else {
        return brand.logo_square;
      }
    }
  }
  getDefaultAvatar (){
    return this.mediaService._fallback_avatar_url;
  }
  handleClick(functionName?: string): boolean {
    if (!functionName) {
      return true;
    }

    const handler = (this as any)[functionName];
    if (typeof handler === 'function') {
      handler.call(this);
    }

    return true;
  }

  doLogout(){
    this.logout.emit();
  }
  filteredAccountDropdownLinks = computed<AccountDropdownLink[]>(() =>  {
    const user = this.user();
    return this.accountDropdownLinks && user
      ? this.accountDropdownLinks.filter(
          link =>
            (link.filteredRoles?.length || 0) < 1
            || this.authService.getMatchingUserRoles(user.roles, link.filteredRoles ?? []).length
            || (link.alwaysVisibleApplications ?? []).includes(this.appKey),
        )
      : [];
  });

  ngOnInit(): void {
    this.currentBrandSubscription = this.brandDisplayService.currentBrand.subscribe( (brand)=>{
      if (brand){
        this.brand.set(brand);
      } else {
        this.brand.set(null);
      }
    });
    this.activeLanguageSubscription = this.languageService.activeLanguageObject.subscribe( activeLanguageObject => {
      this.activeLanguageObject = activeLanguageObject;
    })
  }
}
